import './CurrentRR.scss';
import Component from './CurrentRR.js';
export default Component;
